import React from 'react'
import { Button } from 'antd'
import { MenuUnfoldOutlined } from '@ant-design/icons'

export const RecordHistoryButton: React.FC<{
  loaded: boolean
  hasHistory: boolean
  showHistory: boolean
  onClick: () => void
}> = ({ loaded, hasHistory, showHistory, onClick }) => {
  if (loaded) {
    return (
      <Button
        title="Show/Hide Record History"
        type={showHistory ? 'primary' : 'default'}
        disabled={!hasHistory}
        icon={<MenuUnfoldOutlined rotate={180} />}
        onClick={onClick}
      />
    )
  }

  return null
}
